import { createContext, useContext, useState } from "react";

const GradientContext = createContext();

export const useGradient = () => {
  const context = useContext(GradientContext);

  if (!context) {
    throw new Error("useGradient must be used within a GradientProvider");
  }

  return context;
};

const fixedGradient = "linear-gradient(to right, #2c3e50, #bdc3c7)";

export const GradientProvider = ({ children }) => {
  const [currentGradient] = useState(fixedGradient);

  return (
    <GradientContext.Provider value={{ currentGradient }}>
      {children}
    </GradientContext.Provider>
  );
};
